<template>
  <ProductPageLayout
    name="LongShot"
    :logo="logo"
    :hero-image="heroImage"
    lead="One-click scrolling capture for long pages — smart stitch, preview edit, and OCR so sharing screenshots is faster."
    :feature-lines="featureLines"
    download-link="/ftp/packages/longshot/LongShotSetup.exe"
    download-file-name="LongShotSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="From scrolling capture to stitch and edit — the full screenshot flow in one place."
    other-desc="Capture to share without switching tools."
    reviews-desc="Real feedback that keeps improving LongShot."
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'Longshot',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/longshot/logo_48x48.png'),
      heroImage: require('@/assets/longshot/首页.png'),
      featureLines: [
        'Scrolling capture / smart stitch / preview edit / history',
        'OCR / multi-format export / hotkeys'
      ],
      metaItems: [
        { icon: 'scroll-capture', label: 'Scrolling capture' },
        { icon: 'stitch', label: 'Smart stitch' },
        { icon: 'ocr', label: 'OCR' }
      ],
      detailedFeatures: [
        {
          title: 'Scrolling capture',
          brief: 'Follow page scroll automatically and capture ultra-long content.',
          detail: 'Works on web pages, documents, and chat windows — auto-stitch into one long image instead of manual multi-shot collage.',
          image: require('@/assets/longshot/拼接.png')
        },
        {
          title: 'Smart stitch',
          brief: 'Detect overlaps automatically for natural, seamless edges.',
          detail: 'Image matching finds overlap regions even when scroll speed varies, producing high-quality long screenshots.',
          image: require('@/assets/longshot/拼接.png')
        },
        {
          title: 'Preview & edit',
          brief: 'Preview immediately after capture; crop and annotate before save.',
          detail: 'Built-in editor to crop extras, mark up, or resize output so every long shot is ready to share.',
          image: require('@/assets/longshot/预览编辑.png')
        },
        {
          title: 'OCR',
          brief: 'Extract text from screenshots for quick copy-paste.',
          detail: 'Built-in OCR recognizes text in captures and copies to the clipboard — faster notes and research.',
          image: require('@/assets/longshot/OCR识别.png')
        }
      ],
      otherFeatures: [
        { title: 'History', description: 'Auto-save captures so you can find them later.', icon: 'history' },
        { title: 'Hotkeys', description: 'Global hotkeys trigger capture without breaking your flow.', icon: 'keyboard' },
        { title: 'Export formats', description: 'PNG, JPG, and more — pick what you need.', icon: 'image' },
        { title: 'Local processing', description: 'Capture and OCR stay on your PC — nothing is uploaded.', icon: 'lock' }
      ],
      reviews: [
        { name: 'Harper', comment: 'Tutorials need long web pages — one click now instead of stitching many shots.', avatar: require('@/assets/longshot/avatar1.jpg') },
        { name: 'Indie', comment: 'Competitor pages stitch cleanly; edges are almost invisible.', avatar: require('@/assets/longshot/avatar2.jpg') },
        { name: 'Jules', comment: 'OCR is accurate enough to copy code docs straight into notes.', avatar: require('@/assets/longshot/avatar3.jpg') },
        { name: 'Kai', comment: 'Preview edit lets me crop and mark before sending — no Photoshop detour.', avatar: require('@/assets/longshot/avatar4.jpeg') },
        { name: 'Lane', comment: 'History plus hotkeys make finding old captures painless.', avatar: require('@/assets/longshot/avatar5.jpeg') },
        { name: 'Micah', comment: 'Screenshot + OCR for papers is way faster than retyping.', avatar: require('@/assets/longshot/avatar6.jpeg') }
      ]
    }
  }
}
</script>
